<template lang="pug">
    .usp-info-mobile(v-if="uspWindowVisible",
      @click="onClick",
      :style="infoStyle",
      :class="{visible: visible}",
      ga-category="scene",
      :ga-label="point.gaLabel")
      .content-wrapper(:class="{mobile: isMobile}")
        .text(ref="text") {{uspData ? uspTitle : ''}}
        .arrow
</template>
<script>
import {USPS_LIST} from "@/components/_common/uspsList"
import {mapGetters} from "vuex"
import isMobileMixin from "@/components/mixins/isMobileMixin";
import iframeMixin from "../mixins/iframeMixin";

export default {
  mixins: [isMobileMixin, iframeMixin],
  name: 'USPInfoMobile',
  props: ['point'],
  data () {
    return {
      visible: false,
      timeout: null
    }
  },

  mounted() {
    this.visible = true
  },

  destroyed() {
    clearTimeout(this.timeout)
  },

  watch: {
    uspData() {
      this.visible = true
      // this.timeout = setTimeout(() => {
      //   this.visible = true
      // }, 1)
    }
  },

  computed: {
    ...mapGetters(['uspWindowVisible', 'carModel']),

    uspTitle() {
      return this.uspData.pointName === 'door' ? 'Система бесключевого доступа Kessy' : this.uspData.title
    },

    uspData () {
      let foundedData = null
      for (const data of Array.from(USPS_LIST[this.carModel]).values()) {
        if (data.pointName === this.point.name) {
          foundedData = data
          break
        }
      }
      return foundedData
    },
    infoStyle() {
      return {
        top: this.point.screenPosition.y + 'px',
        left: this.point.screenPosition.x +  'px',
        zIndex: 10000,
        minHeight: this.isMobile ? '46px' : '46px',
        opacity: this.point.opacity,
        height: this.$refs.text ? this.$refs.text.getBoundingClientRect().height + 'px' : 0,
      }
    }
  },
  methods: {
    onClick () {
      this.postIframeEvent('show_' + this.uspData.gaLabel)
      this.$emit('click')
    }
  }
}
</script>